export const STARTED = 'STARTED'
export const PAUSED = 'PAUSED'
export const UNPAUSED = 'UNPAUSED'
export const IN_PROGRESS = 'IN_PROGRESS'
export const FINISHED = 'FINISHED'
export const configElements = ['format.output']
